import { Transform } from "../../math";
import { isArray } from "lodash";
export var TileTransform;
(function (TileTransform) {
    function normalize(t) {
        return isArray(t) ? {
            matrix: t,
            level_offset: 0
        } : t;
    }
    TileTransform.normalize = normalize;
    function lift(t, level_offset = 0) {
        return {
            matrix: t,
            level_offset: level_offset
        };
    }
    TileTransform.lift = lift;
    function mult(a, b) {
        let norm_a = normalize(a);
        let norm_b = normalize(b);
        return lift(Transform.mult(norm_a.matrix, norm_b.matrix), norm_a.level_offset + norm_b.level_offset);
    }
    TileTransform.mult = mult;
    function chain(...transforms) {
        let trans = identity();
        for (let transform of transforms) {
            trans = mult(trans, transform);
        }
        return trans;
    }
    TileTransform.chain = chain;
    function translation(offset, level_offset) {
        return {
            matrix: Transform.translation(offset),
            level_offset: level_offset
        };
    }
    TileTransform.translation = translation;
    function identity() {
        return {
            matrix: Transform.identity(),
            level_offset: 0
        };
    }
    TileTransform.identity = identity;
})(TileTransform || (TileTransform = {}));
